module.exports = {
  SET_FREE_SHIPPING: 'SET/FREE_SHIPPING',
};
